import { BrowserRouter, Route, Switch } from 'react-router-dom';
import Header from './component/misc/Header';
import Footer from './component/misc/Footer';
import Home from './pages/HomePage';
import About from './pages/AboutPage';
import Contact from './pages/ContactPage';
import Error from './component/misc/Error';
import Privacy from './component/Others/Privacy';

function App() {
  return (
    <>
      <BrowserRouter>
        <Header />
        <Switch>
          <Route path="/" exact component={Home} />
          <Route path="/about" exact component={About} />
          <Route path="/contact" exact component={Contact} />
          <Route path="/privacy" exact component={Privacy} />
          <Route path="/" component={Error} />
        </Switch>
        <Footer />
      </BrowserRouter>
    </>
  );
}

export default App;
